// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","sideBySide":"About_sideBySide__ViSty","left":"About_left__GDCNx","right":"About_right__yglFo","mountains":"About_mountains__EsUFz"};